/**
 * De QR-code, zoals de API hem tekent.
 *
 * Een `<img>` naar het PNG-endpoint en geen QR-bibliotheek in de browser: de
 * code die je op het scherm ziet is dan gegarandeerd dezelfde als die op het
 * gedrukte kaartje, want er is maar één plek die hem maakt.
 */
export function QrCode({
  src,
  size,
  className = '',
}: {
  src: string
  size: number
  className?: string
}) {
  return (
    <div
      style={{ width: size, height: size }}
      className={'shrink-0 rounded-[10px] bg-white p-3 ' + className}
    >
      <img
        src={src}
        alt="QR-code van dit event"
        width={size}
        height={size}
        className="h-full w-full"
      />
    </div>
  )
}

/**
 * Het kleine QR-vierkantje op een eventkaart. Geen echte code — het is een
 * knopje dat naar de QR-pagina wijst, en een leesbare code op 44px bestaat
 * niet.
 */
export function QrGlyph({ size = 44 }: { size?: number }) {
  return (
    <span
      aria-hidden="true"
      style={{ width: size, height: size, padding: size * 0.14 }}
      className="border-line-card bg-surface grid grid-cols-3 grid-rows-3 gap-0.5 rounded-[10px] border"
    >
      {[1, 0, 1, 0, 1, 0, 1, 0, 1].map((filled, index) => (
        <span key={index} className={filled ? 'bg-ink' : ''} />
      ))}
    </span>
  )
}
